/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Totals from saved player-attributed statistics for published completed matches. Percentages use summed counts, not averages of match percentages; null means no attempts.
 * @export
 * @interface PerformanceStatistics
 */
export interface PerformanceStatistics {
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    attempts?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    goals?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    sevenMeterAttempts?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    sevenMeterGoals?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    shotsFaced?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    saves?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    goalsConceded?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    sevenMeterShotsFaced?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    sevenMeterSaves?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    blocks?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    turnovers?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    technicalFaults?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    lostBalls?: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    shootingPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    sevenMeterPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    savePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PerformanceStatistics
     */
    sevenMeterSavePercentage?: number | null;
}

/**
 * Check if a given object implements the PerformanceStatistics interface.
 */
export function instanceOfPerformanceStatistics(value: object): value is PerformanceStatistics {
    return true;
}

export function PerformanceStatisticsFromJSON(json: any): PerformanceStatistics {
    return PerformanceStatisticsFromJSONTyped(json, false);
}

export function PerformanceStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformanceStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'attempts': json['attempts'] == null ? undefined : json['attempts'],
        'goals': json['goals'] == null ? undefined : json['goals'],
        'sevenMeterAttempts': json['sevenMeterAttempts'] == null ? undefined : json['sevenMeterAttempts'],
        'sevenMeterGoals': json['sevenMeterGoals'] == null ? undefined : json['sevenMeterGoals'],
        'shotsFaced': json['shotsFaced'] == null ? undefined : json['shotsFaced'],
        'saves': json['saves'] == null ? undefined : json['saves'],
        'goalsConceded': json['goalsConceded'] == null ? undefined : json['goalsConceded'],
        'sevenMeterShotsFaced': json['sevenMeterShotsFaced'] == null ? undefined : json['sevenMeterShotsFaced'],
        'sevenMeterSaves': json['sevenMeterSaves'] == null ? undefined : json['sevenMeterSaves'],
        'blocks': json['blocks'] == null ? undefined : json['blocks'],
        'turnovers': json['turnovers'] == null ? undefined : json['turnovers'],
        'technicalFaults': json['technicalFaults'] == null ? undefined : json['technicalFaults'],
        'lostBalls': json['lostBalls'] == null ? undefined : json['lostBalls'],
        'shootingPercentage': json['shootingPercentage'] == null ? undefined : json['shootingPercentage'],
        'sevenMeterPercentage': json['sevenMeterPercentage'] == null ? undefined : json['sevenMeterPercentage'],
        'savePercentage': json['savePercentage'] == null ? undefined : json['savePercentage'],
        'sevenMeterSavePercentage': json['sevenMeterSavePercentage'] == null ? undefined : json['sevenMeterSavePercentage'],
    };
}

export function PerformanceStatisticsToJSON(json: any): PerformanceStatistics {
    return PerformanceStatisticsToJSONTyped(json, false);
}

export function PerformanceStatisticsToJSONTyped(value?: PerformanceStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attempts': value['attempts'],
        'goals': value['goals'],
        'sevenMeterAttempts': value['sevenMeterAttempts'],
        'sevenMeterGoals': value['sevenMeterGoals'],
        'shotsFaced': value['shotsFaced'],
        'saves': value['saves'],
        'goalsConceded': value['goalsConceded'],
        'sevenMeterShotsFaced': value['sevenMeterShotsFaced'],
        'sevenMeterSaves': value['sevenMeterSaves'],
        'blocks': value['blocks'],
        'turnovers': value['turnovers'],
        'technicalFaults': value['technicalFaults'],
        'lostBalls': value['lostBalls'],
        'shootingPercentage': value['shootingPercentage'],
        'sevenMeterPercentage': value['sevenMeterPercentage'],
        'savePercentage': value['savePercentage'],
        'sevenMeterSavePercentage': value['sevenMeterSavePercentage'],
    };
}

